// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import Close from "@werner/XDL/Icons/Close";
import { buttonTransparent } from "@werner/XDL/PreStyle/button";
import { xBaseTheme } from "@werner/XDL/types";
import { getSystemColor } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        color: "common.ui1",
        typographyProps: {
            size: 15,
            weight: 400,
            color: getSystemColor("common.white"),
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: 28px;
            `,
        },
        iconProps: {
            size: 8,
            src: Close,
            color: "common.white",
        },
        css: css`
            min-height: 28px;
            border-radius: 35px;
            flex-direction: row;
            align-items: flex-start;
            padding: 4px 12px;
            margin: 0 8px 8px 0;
            button {
                margin-top: 8px;
                margin-right: 8px;
                height: 12px;
                ${buttonTransparent}
            }
        `,
    },
} as xBaseTheme["tag"];
